"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CircularProgress_1 = require("@material-ui/core/CircularProgress/CircularProgress");
var InputAdornment_1 = require("@material-ui/core/InputAdornment/InputAdornment");
var TextField_1 = require("@material-ui/core/TextField/TextField");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var React = require("react");
var config_1 = require("../config");
var FieldText = /** @class */ (function (_super) {
    tslib_1.__extends(FieldText, _super);
    function FieldText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            var value = _this.cleanValue(event.target ? event.target.value : event);
            config_1.getConfig().validationOn === 'onChange' && _this.setState({ showError: true });
            _this.props.onChange(value);
        };
        _this.onBlur = function (e) {
            _this.props.onBlur && _this.props.onBlur(e);
            config_1.getConfig().validationOn === 'onBlur' && _this.setState({ showError: true });
        };
        return _this;
    }
    FieldText.prototype.getValue = function () {
        return this.mask.apply(this.props.value);
    };
    FieldText.prototype.cleanValue = function (value) {
        return this.mask.clean(value);
    };
    FieldText.prototype.render = function () {
        var value = this.getValue();
        var _a = this.props, loading = _a.loading, helperText = _a.helperText, multiline = _a.multiline, validationContext = _a.validationContext, extraProps = tslib_1.__rest(_a, ["loading", "helperText", "multiline", "validationContext"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement(TextField_1.default, tslib_1.__assign({}, tslib_1.__assign({ fullWidth: true, margin: 'normal', rows: multiline ? 4 : null }, extraProps, { multiline: multiline, required: this.isRequired, value: (value === undefined || value === null ? '' : value).toString(), error: !!this.errorMessage, helperText: this.errorMessage || helperText, onChange: this.onChange, onBlur: this.onBlur, submitted: null, touched: null, loading: null }), { InputProps: tslib_1.__assign({ endAdornment: !loading ? null : (React.createElement(InputAdornment_1.default, { position: 'end' },
                        React.createElement(CircularProgress_1.default, { color: 'secondary', size: 20 }))) }, (extraProps.InputProps || {})) }))));
    };
    return FieldText;
}(FieldCoreBase_1.default));
exports.default = FieldText;
//# sourceMappingURL=Text.js.map